import api from '../token';

export const AlterCambio = async (dados) => {
  try {
    const response = await api.post('/alterCambio', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};
